import React from 'react'
import { connect } from 'react-redux'
import { Tag, Tooltip } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import classNames from 'classnames'
import { AttributeTooltip } from './AttributeTooltip'

import './index.scss'

const SegmentTag = (props) => {
  const { data, groupIndex, index, delSegment, dimensions, toggleDimensionModal, setCurrentGroup, setSegmentationState } = props

  const renderSegmentOperator = (type, operator) => {
    const segmentType = dimensions?.find((item) => item?.code === type)
    const opera = segmentType?.operator?.find((item) => item?.code === operator)
    if (!opera) return ''
    return opera?.name
  }

  const renderSegmentType = (type) => {
    return dimensions?.find((item) => item.code === type)?.name
  }

  const renderSegmentValue = (type, dimValue) => {
    if (typeof dimValue === 'number') return Number(dimValue)?.toLocaleString()

    const segmentType = dimensions?.find((item) => item?.code === type)
    const value =
      segmentType.values?.find((item) => item?.code === dimValue) ||
      segmentType.value?.find((item) => item?.code === dimValue)

    return value?.name
  }

  const renderInLast = (data) => {
    if (!data.in_last) return ''
    return `in last ${data.in_last} ${data.time_format}`
  }

  const renderEverydayAt = (data) => {
    if (!data.time) return ''
    return `every day at ${data.time}`
  }

  // const renderTag = (data) => {
  //   let result = `${renderSegmentType(data.type)} ${renderSegmentOperator(
  //     data.type,
  //     data.operator
  //   )} ${renderSegmentValue(data.type, data.value)} ${renderInLast(data)} ${renderEverydayAt(data)}`

  //   let newResult = result

  //   if (result.includes('= true')) {
  //     newResult = result.replace('= true', '')
  //   }

  //   if (result.includes('= false')) {
  //     newResult = result.replace('= false', '').replace(/is/i, 'Is not ')
  //   }

  //   return newResult
  // }

  const renderTag = (data) => {
    const segmentTypeName = renderSegmentType(data?.type)
    const operator = renderSegmentOperator(data?.type, data?.operator)
    
    // Format the value for display
    let valueDisplay = data?.value || ''
    if (typeof valueDisplay === 'string') {
      // Handle product and category IDs
      if (valueDisplay.includes('PRODUCT_') || valueDisplay.includes('CATEGORY_')) {
        const items = valueDisplay.split(',')
        if (items.length > 1) {
          valueDisplay = `${items[0].trim().substring(0, 20)}... (+${items.length - 1})`
        } else {
          valueDisplay = items[0].trim().substring(0, 30) + (items[0].length > 30 ? '...' : '')
        }
      }
    }
    
    let result = `${segmentTypeName} ${operator} ${valueDisplay}`
    
    if (data?.time_operator || data?.time_value) {
      result += ` ${data?.time_operator || ''} ${data?.time_value || ''}`
    }

    return result.trim()
  }

  const handleTagClick = (e) => {
    e.stopPropagation()
    // Set the current group for editing
    setCurrentGroup({ index: groupIndex })
    // Set editing mode with current data
    if (setSegmentationState) {
      setSegmentationState({ key: 'editingSegment', value: { index, data } })
    }
    // Open the dimension modal
    toggleDimensionModal()
  }

  return (
    <Tag
      visible={true}
      closeIcon={<CloseOutlined />}
      className={classNames('SegmentTagComponent attribute-tag')}
      closable
      onClose={() => delSegment({ groupIndex, index })}
      onClick={handleTagClick}
    >
      <Tooltip 
        title={<AttributeTooltip data={data} dimensions={dimensions} />}
        overlayClassName="attribute-tooltip-overlay"
        placement="top"
      >
        <span style={{ cursor: 'pointer', maxWidth: '280px' }} className="truncate">
          {renderTag(data)}
        </span>
      </Tooltip>
    </Tag>
  )
}

export default connect(
  (state) => ({
    dimensions: state.segmentation.dimensions,
  }),
  (dispatch) => ({
    delSegment: dispatch.segmentation.delSegment,
    toggleDimensionModal: dispatch.segmentation.toggleDimensionModal,
    setCurrentGroup: dispatch.segmentation.setCurrentGroup,
    setSegmentationState: dispatch.segmentation.setState,
  })
)(SegmentTag)
